import React from 'react';
import { Route, Navigate, Routes } from 'react-router-dom';
import RoutePrivate from 'components/Route/Private/Private';
import ScreensPropertyForm from './Form/ScreensPropertyForm';
import ScreensPropertyList from './List/ScreensPropertyList';
import ScreensPropertyLinked from './Linked/ScreensPropertyLinked';

function ScreensProperty() {
  return (
    <Routes>
      <Route
        path="/create"
        element={
          <RoutePrivate
            element={ScreensPropertyForm}
            requiredPermission="properties.create"
          />
        }
      />
      <Route
        path="/:id/edit"
        element={
          <RoutePrivate
            element={ScreensPropertyForm}
            requiredPermission="properties.update"
          />
        }
      />
      <Route
        path="/:id/linked"
        element={
          <RoutePrivate
            element={ScreensPropertyLinked}
            requiredPermission="properties.update"
          />
        }
      />
      <Route
        path="/list"
        element={
          <RoutePrivate
            element={ScreensPropertyList}
            requiredPermission="properties.update"
          />
        }
      />
      <Route path="/" element={<Navigate replace to="/properties/list" />} />
    </Routes>
  );
}

export default ScreensProperty;
